import { inherits as _inherits, classCallCheck as _classCallCheck, createClass as _createClass, slicedToArray as _slicedToArray, createSuper as _createSuper } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { pixelsFor } from './index.js';
import { CachedDOMMeasurement as CachedDOMMeasurement$1 } from './CachedDOMMeasurement.js';

/** Measures the innermost width of an element, *inside* its padding. */

var CachedInnerWidth = /*#__PURE__*/function (_CachedDOMMeasurement) {
  _inherits(CachedInnerWidth, _CachedDOMMeasurement);

  var _super = _createSuper(CachedInnerWidth);

  function CachedInnerWidth() {
    _classCallCheck(this, CachedInnerWidth);

    return _super.apply(this, arguments);
  }

  _createClass(CachedInnerWidth, [{
    key: "getValue",
    value: function getValue() {
      var el = this.element();
      if (!el) return 0;
      var clientWidth = el.clientWidth;

      var _this$padding = _slicedToArray(this.padding, 2),
          paddingLeft = _this$padding[0],
          paddingRight = _this$padding[1];

      return clientWidth - paddingLeft - paddingRight;
    }
  }, {
    key: "padding",
    get: function get() {
      var style = getComputedStyle(this.element());
      return ['padding-left', 'padding-right'].map(function (p) {
        return pixelsFor(p, style);
      });
    }
  }]);

  return CachedInnerWidth;
}(CachedDOMMeasurement$1);

export { CachedInnerWidth };
